import React from 'react';

const ProductFeedbackForm = () => {
    return (
        <div className={"text-center form-colour"}>
            <iframe className={"rounded col-10 google-form"}
                src="https://docs.google.com/forms/d/e/1FAIpQLSejAPDoATv49J6z3pRxrNFbiuZJasXnMD4SIPs_DivYBcQvaw/viewform"
                title="External Page" 
            ></iframe>
        </div>
    );
};

export default ProductFeedbackForm;